import pptxgen from "pptxgenjs";

const pptxTotalWidth = 10; // in inches, for a 16:9 slide

export const convertHorizontalDimToHtmlPercent = (xIn?: pptxgen.Coord) => {
  if (xIn === undefined) return undefined; // return as string with % sign
  return ((xIn as number) / pptxTotalWidth) * 100;
};
